import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";

const ChartContent = (props) => {
  var labelArray = [];
  props.data?.allUserInfo?.map((chart) => labelArray.push(chart.day));
  var labelArrayY = [];
  props.data?.allUserInfo?.map((chart) =>
    labelArrayY.push(Math.round(chart.count))
  );
  const state = {
    labels: labelArray,
    datasets: [
      {
        fill: false,

        backgroundColor: "transparent",
        borderColor: "#f4b8b8",
        borderWidth: 2,
        data: labelArrayY,
      },
    ],
  };
  const Options =
  {
    plugins: {
      title: {
        display: false,
        fontSize: 20,
      },
      legend: {
        display: false,
      }
    }
  }
  return (
    <div className="chart-content col-12">
      <div className="col-12 text-right">
        <p className="text_dashboard_style">ثبت نام کاربران 30 روز اخیر</p>
      </div>
      <Line
        data={state}
        options={Options}
      />
    </div>
  );
};

export default ChartContent;
